import { render } from "./App.vue?vue&type=template&id=aa02b686"
const script = {}

import "./App.vue?vue&type=style&index=0&id=aa02b686&lang=scss"

import exportComponent from "/Users/mmartinez/Desktop/personal/suburban relapse/suburban-relapse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__